import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CloseIcon from "@mui/icons-material/Close";
import { DialogContent, DialogTitle, IconButton } from "@mui/material";
import { useSelector } from "react-redux";

import Form from "./Form";
import List from "./List";
import { useResponsive } from "../../../../hooks/useResponsive";
import { CustomButton } from "../../../../components/Button/Button";
import useBoardIdByKey from "../../../../hooks/useBoardIdByKey";
import { useBoardAttachmentForm } from "./hooks/useBoardAttachmentForm";

export default function AnchorTemporaryDrawer({ toggleDrawer, state }) {
  const { id } = useBoardIdByKey();
  const userData = useSelector((state) => state.users.logInUser);
  const isMobile = useResponsive("down", "md");
  const {
    canSubmit,
    file,
    handleDrawerClose,
    handleFileChange,
    handleNameChange,
    handleSubmit,
    isPending,
    name,
  } = useBoardAttachmentForm({
    boardId: id,
    toggleDrawer,
    userId: userData.user_id,
  });

  const drawerWidth = React.useMemo(
    () => ({
      mobile: 300,
      desktop: 520,
    }),
    []
  );

  const list = (anchor) => (
    <Box
      sx={{
        width: isMobile
          ? drawerWidth.mobile
          : anchor === "top" || anchor === "bottom"
          ? "auto"
          : drawerWidth.desktop,
      }}
      role="presentation"
    >
      <DialogTitle
        id="customized-dialog-title"
        className="blue-text-color attachment-header-text d-flex justify-content-space-between dialog-title-bgcolor"
      >
        Attachments
        <div className="mr-40">
          <CustomButton
            onClick={() => {
              handleSubmit();
            }}
            variant="contained"
            className="theme-bg-color add-attachment-btn"
            disabled={!canSubmit || isPending}
          >
            {isPending ? "Loading..." : "Add"}
          </CustomButton>
        </div>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => handleDrawerClose(anchor)}
        className="add-attachment-crossBtn"
      >
        <CloseIcon />
      </IconButton>
      <DialogContent className={isMobile ? "attachment-content" : ""}>
        <Form
          file={file}
          name={name}
          handleNameChange={handleNameChange}
          handleFileChange={handleFileChange}
          isMobile={isMobile}
        />
        <Box sx={{ height: "24px" }}></Box>
        <List isMobile={isMobile} />
      </DialogContent>
    </Box>
  );

  return (
    <div>
      {["right"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={() => handleDrawerClose(anchor)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
